import React, { useEffect } from "react";

type Event = MouseEvent | TouchEvent;

export function useOnClickOutside(
  ref: React.RefObject<HTMLElement>,
  handler: (event: Event) => void,
  actionRef?: React.RefObject<HTMLElement>
) {
  useEffect(() => {
    const listener = (event: Event) => {
      if (
        !ref.current ||
        ref.current.contains((event?.target as Node) || null)
      ) {
        return;
      }

      if (handler) {
        if (
          actionRef?.current &&
          actionRef.current.contains((event?.target as Node) || null)
        )
          return;
        handler(event);
      }
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
}
